import CreditorInfo from './CreditorInfo.js';
export default CreditorInfo;
//# sourceMappingURL=index.js.map